import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'trimDeleted',
    pure: true,
    standalone: false
})
export class TrimDeletedEmail implements PipeTransform {

    transform(value: string, ...args: string[]): string {
        return value.slice(0, 30);
    }

}
